import { render } from "./Customer.html?vue&type=template&id=5e9d9e1c&scoped=true&ts=true"
import script from "./Customer.ts?vue&type=script&lang=ts"
export * from "./Customer.ts?vue&type=script&lang=ts"

import "./Customer.css?vue&type=style&index=0&id=5e9d9e1c&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9d9e1c"]])

export default __exports__